import { motion } from "framer-motion";

export default function Services() {
    const services = [
        { icon: "👰‍♀️", title: "Weddings", subtitle: "Royal Sparkle" },
        { icon: "💼", title: "Corporate Events", subtitle: "Professional Touch" },
        { icon: "🎂", title: "Birthdays", subtitle: "Confetti Fun!" },
        { icon: "💍", title: "Engagements", subtitle: "Shining Moments" },
        { icon: "🧿", title: "Traditional Ceremonies", subtitle: "Mandala Blessings" },
        { icon: "🧁", title: "Private Parties", subtitle: "Colorful Vibes" },
    ];

    const premium = [
        { icon: "🔥", title: "Live Counters" },
        { icon: "🍽️", title: "Plated Service" },
        { icon: "🍛", title: "Buffet Setup" },
        { icon: "🎁", title: "Customized Menus" },
        { icon: "🎙️", title: "Emcee & Hosting" },
        { icon: "📷", title: "Photo-worthy Styling" },
    ];

    const fadeUp = {
        hidden: { opacity: 0, y: 30 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, duration: 0.6, ease: "easeOut" },
        }),
    };

    return (
        <section
            id="services"
            className="py-24 text-center px-6 md:px-20 font-[Playfair_Display]"
            style={{
                background: "#FFFFFF",
                color: "#1F2937",
            }}
        >
            {/* Header */}
            <motion.div
                className="flex flex-col items-center mb-12"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
            >
        <span
            className="px-6 py-2 rounded-full text-sm font-semibold tracking-wide mb-4 shadow-md"
            style={{
                background:
                    "linear-gradient(135deg, #D4AF37 0%, #e0c168 50%, #B88A2D 100%)",
                color: "#FFFFFF",
            }}
        >
          OUR SERVICES
        </span>

                <h2 className="text-4xl md:text-5xl font-semibold mb-3 text-[#1F2937]">
                    ✨ Our Culinary Experiences
                </h2>
                <p className="max-w-2xl mx-auto text-lg italic text-[#4B5563]">
                    Crafting unforgettable moments through food & service
                </p>
            </motion.div>

            {/* Main Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-16">
                {services.map((item, i) => (
                    <motion.div
                        key={i}
                        className="p-8 rounded-2xl transition-all duration-300 transform hover:scale-[1.03]"
                        style={{
                            background: "#F9FAFB",
                            border: "1px solid rgba(212,175,55,0.4)",
                            boxShadow:
                                "0 4px 20px rgba(0,0,0,0.1)",
                        }}
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        custom={i}
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <div className="text-4xl mb-3">{item.icon}</div>
                        <h3 className="text-2xl font-semibold text-[#1F2937]">
                            {item.title}
                        </h3>
                        <p className="text-[#D4AF37] italic text-sm mt-2">
                            {item.subtitle}
                        </p>
                    </motion.div>
                ))}
            </div>

            {/* Premium Grid */}
            <motion.div
                className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
            >
                {premium.map((item, i) => (
                    <motion.div
                        key={i}
                        className="py-6 px-3 rounded-xl transition-all duration-300"
                        style={{
                            background: "#F9FAFB",
                            border: "1px solid rgba(212,175,55,0.3)",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        }}
                        variants={fadeUp}
                        custom={i}
                        whileHover={{
                            scale: 1.05,
                            boxShadow: "0 4px 20px rgba(212,175,55,0.3)",
                            borderColor: "#D4AF37",
                        }}
                    >
                        <div className="text-2xl mb-2">{item.icon}</div>
                        <h4 className="text-[#1F2937] text-sm font-medium">
                            {item.title}
                        </h4>
                    </motion.div>
                ))}
            </motion.div>

            {/* Footer Badge */}
            <motion.div
                className="mt-10 text-[#D4AF37] text-sm italic"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.6 }}
                viewport={{ once: true }}
            >

            </motion.div>
        </section>
    );
}

